import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { ModalXacNhanDuyet } from "./ModalXacNhanDuyet";

export const BtnXacNhanDuyet = ({ item }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <a onClick={handleShow} href={() => false}>
        <PopoversBootrap
          contentText="Duyệt"
          trigger={["hover", "focus"]}
          placement={"top"}
        >
          <i className="fas fa-user-check" style={{scale:"80%"}}></i>
        </PopoversBootrap>
      </a>

      {show && (
        <ModalXacNhanDuyet
          show={show}
          onHide={handleClose}
          chovayId={item.ChoVayId}
          item={item}
        />
      )}
    </>
  );
};
